import { useState } from 'react';
import { Trans, t } from '@lingui/macro';
import { AvatarWithLabel, Button, Dialog, DialogContent, DialogFooter, DialogHeader, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ContractTemplateList } from 'app/domains/templates';
export function TemplateBrowserModal(props) {
    const { onClose, onSubmit, open } = props;
    const [selectedIds, setSelectedIds] = useState(null);
    const handleSubmit = () => {
        if (selectedIds) {
            onSubmit(selectedIds);
        }
    };
    const title = t({
        message: 'Select template',
        comment: 'Composer Browser Modal - Header text',
    });
    if (!open) {
        return null;
    }
    return (<Dialog onClose={onClose}>
      <DialogHeader media={<AvatarWithLabel size="xl" shape="square" title={title}>
            <Falcon icon="file-upload"/>
          </AvatarWithLabel>}/>
      <DialogContent>
        <ContractTemplateList onSelect={setSelectedIds}/>
      </DialogContent>
      <DialogFooter>
        <Button appearance="secondary" onClick={onClose}>
          <Trans comment="Composer Browser Modal - Close button">Close</Trans>
        </Button>
        <Button appearance="primary" onClick={handleSubmit} disabled={!selectedIds}>
          <Trans comment="Composer Browser Modal - Select button">Select</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
